module.exports = __webpack_public_path__ + "media/images/favicon/favicon-7faf23a9d8971e931e79cb0082df2edc.ico";